import type { FaireProductEntity } from "../../entity_types/product";

export const p_edb5wsu9sa: FaireProductEntity = {
  token: "p_edb5wsu9sa",
  type: "product",
  name: "Bulk Cacao Butter",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/69c65db2d2e05dd891fdfa4a320bffab8431cd27fdf10e1b97cb36985bef6b16.jpeg",
  galleryImageUrls: [],
  priceDollars: 135,
  description:
    "Premium organic certified cacao butter from our direct and ethical trade farming network, the best we've been able to source. This is important because the majority of cacao butter on the market actually comes from the lowest grade, often moldy or otherwise defective cacao beans. \n\nNatural (not deodorized).\n\nUseful for body butters and cacao recipes that require additional cacao butter for creaminess or to balance addition of superfoods.\n\nMay come in large chunks or discs. To use in recipes, just place in a double boiler to melt.",
  tags: [],
  msrpDollars: 270,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:48.823Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
